module.exports = __webpack_public_path__ + "storeHome/img/limited-img-1111.b86e45d9.png";